import Tool from '../../../tools/tool';
import UnitEditorApp from '../unit-editor-app';
import logging from '../../../logging';
import { MOUSE, TOUCH, Vector3 } from 'three';
import { MapControls } from 'three/examples/jsm/controls/MapControls.js';
import Signal from '../../../control-flow/signal';


const log = logging('tools');

/**
 * This orbit tool wraps the three.js OrbitControls.
 */
export class PanZoomTool extends Tool {

    target: Vector3 = new Vector3(12.75, 42, 0);

    private app: UnitEditorApp;
    private controls: MapControls;

    onChange = new Signal('onChange', 'tools');

    constructor(app: UnitEditorApp) {
        super();

        this.app = app;

        this.controls = new MapControls(
            app.pipeline.camera, app.pipeline.canvas);

        this.controls.mouseButtons.LEFT = undefined;
        this.controls.mouseButtons.RIGHT = MOUSE.PAN;
		this.controls.touches.ONE = undefined;
		this.controls.touches.TWO = TOUCH.DOLLY_PAN;

        // Always remain centered on the target by disabling panning
        this.controls.enablePan = true;
        this.controls.enableDamping = true;
        this.controls.dampingFactor = 0.25;
        this.controls.screenSpacePanning = true;
        this.controls.minDistance = 24;
        this.controls.maxDistance = 90;
        this.controls.minAzimuthAngle = -Math.PI/2;
        this.controls.maxAzimuthAngle = Math.PI/2;
        this.controls.target = this.target;
        this.controls.enabled = true;

        this.controls.update();
    }

    enable(): void {
        log.debug('PanZoomTool.enable()');
        this.controls.enabled = true;
        this.controls.object = this.app.pipeline.camera;
        // remove a listener fist to avoid double registration
        this.app.pipeline.canvas.removeEventListener(
            'pointerdown', this.begin);
        this.app.pipeline.canvas.addEventListener('pointerdown', this.begin);

        this.app.pipeline.canvas.removeEventListener('wheel', this.onChange.trigger);
        this.app.pipeline.canvas.addEventListener('wheel', this.onChange.trigger);

        this.update();
    }

    disable(): void {
        log.debug('PanZoomTool.disable()');
        this.controls.enabled = false;
        this.app.pipeline.canvas.removeEventListener('pointerdown', this.begin);
        this.app.pipeline.canvas.removeEventListener('wheel', this.onChange.trigger);
    }

    // We expect to be activated by a pointerdown event
    begin(): void {
        log.debug('PanZoomTool.begin()');
        // Every time we activate, we update the controls' reference to the
        // camera since the pipeline's camera object could change
        this.controls.object  = this.app.pipeline.camera;
        this.controls.addEventListener('change', this.onChange.trigger);
        this.app.pipeline.onBeforeRender.add(this.update);

        window.addEventListener('pointerup', this.end, {once: true});
    }

    cancel(): void {
        log.debug('PanZoomTool.cancel()');
        this.controls.removeEventListener('change', this.onChange.trigger);
        this.app.pipeline.onBeforeRender.delete(this.update);
    }

    end(): void {
        log.debug('PanZoomTool.end()');
        this.cancel();
    }

    /**
     * Called before render to update the controls
     */
    private update = (): void => {
        //log.debug('PanZoomTool.update()');
        if(this.controls.enabled) this.controls.update();
    }

}
export default PanZoomTool;
